import React from 'react';
import { Filter as FilterAdmin, SelectInput } from 'react-admin';

import {
  CompetenciaInput,
  PeriodoInput,
} from '../../Components/InputsReactAdmin';

const choicesTipo = [
  { id: 'ingestao', name: 'Ingestão' },
  { id: 'pacote_mensal', name: 'Pacote Mensal' },
];

const choicesStatus = [
  { id: 'pendente', name: 'Pendente' },
  { id: 'processando', name: 'Processando' },
  { id: 'sucesso', name: 'Sucesso' },
  { id: 'sucesso_com_pendencias', name: 'Sucesso com pendências' },
  { id: 'erro', name: 'Erro' },
  { id: 'cancelada', name: 'Cancelada' },
];

const choicesOrigem = [
  { id: 'agendada', name: 'Agendada' },
  { id: 'manual', name: 'Manual' },
  { id: 'reprocessamento', name: 'Reprocessamento' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <SelectInput source="tipo" choices={choicesTipo} label="Tipo" />
    <SelectInput source="status" choices={choicesStatus} label="Status" />
    <SelectInput source="origem" choices={choicesOrigem} label="Origem" />
    <CompetenciaInput source="competencia" label="Competência" />
    <PeriodoInput source="periodo" label="Período (criação)" />
  </FilterAdmin>
);

export default Filter;
